/*eslint-disable*/
import store from "../store";
import { User } from '../FackApi/api/user'

export default class socket_listener {
  socket = null;
  store = null
  constructor(context, socket) {
    this.socket = socket;
    this.store = store

    // Test Socket message from API_SERVICE
    this.socket_message_from_api_svc(this);

    // Chatbot Prompt Edit Listener
    this.socket_chatbot_prompt_edit(this);
  }

  /**
   * socket_message_from_api_svc
   */
  socket_message_from_api_svc(context) {
    // message_from_api_service
    this.socket.on("message_from_api_service", function(message) {
      console.log("Sender of the message is: ", message)
    });
  }

  /**
   * socket_chatbot_prompt_edit
   */
  socket_chatbot_prompt_edit(context) {
    this.socket.on("chatbot_prompt_edit", (response) => {
      this.store.dispatch("QuizBotMsg/updatePromptResponse", response);
    });
  }
}
